import React from 'react'
import Testimonial from './Testimonial'

function About() {
 return (
 <div>
 <div className="container-fluid bg-primary py-5 mb-5 hero-header">
 <div className="container">

   <div className="row justify-content-center">
 <div className="col-lg-10 text-center">
 <h1 className="display-3 text-white animated slideInDown">
 A propos
 </h1>
 <nav aria-label="breadcrumb">
 <ol className="breadcrumb justify-content-center">
 <li className="breadcrumb-item">
 <a href="/" style={{color:'#2B4C7E'}}>Acceuil</a>
 </li>
 {/* <li className="breadcrumb-item">
 <a href="/Pages">Pages</a>
 </li> */}
 <li
 className="breadcrumb-item text-white active"
 aria-current="page"
 >
 A propos
 </li>
 </ol>
 </nav>
 </div>
 </div>
 </div>
 </div>
 
 {/* About Start */}
 <div className="container-xxl py-5">
 <div className="container">
 <div className="row g-5">
 <div
 className="col-lg-6 wow fadeInUp"
 data-wow-delay="0.1s"
 style={{ minHeight: 400 }}
 >
 <div className="position-relative h-100">
 <img
 className="img-fluid position-absolute w-100 h-100"
 src="assets/img/logo1.png"
 alt=""
 style={{ objectFit:"cover" }}
 />
 </div>
 </div>
 <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.3s">
 <h6 className="section-title bg-white text-start pe-3" style={{color:'#2B4C7E'}}>
 À Propos
 </h6>
 <h2 className="mb-4">
 Bienvenue chez <span style={{color:'#2B4C7E'}}>Aviator Travel </span> Services
 </h2>
 <p className="mb-4">
 Chez Aviator Travel Service – ATS Enaser, basés à Ariana, en Tunisie, nous nous spécialisons dans la création de voyages mémorables et d'expériences de voyage sur mesure pour les particuliers, les familles et les groupes.
 </p>
 <p className="mb-4">
 Avec une passion pour l'exploration de nouvelles destinations et un engagement envers un service de haute qualité,
 nous vous aidons à découvrir à la fois des trésors locaux et des aventures internationales.
 Laissez-nous prendre en charge la planification de votre voyage, afin que vous puissiez vous concentrer sur le moment présent.
 </p>
 <div className="row gy-2 gx-4 mb-4">
 <div className="col-sm-6">
 <p className="mb-0">
 <i className="fa fa-arrow-right text-primary me-2" />
 Réservation d'hotels en Tunisie et à l'étranger
 </p>
 </div>
 <div className="col-sm-6">
 <p className="mb-0">
 <i className="fa fa-arrow-right text-primary me-2" />
 Billeterie
 </p>
 </div>
 <div className="col-sm-6">
 <p className="mb-0">
 <i className="fa fa-arrow-right text-primary me-2" />
 Voyages organisés
 </p>
 </div>
 <div className="col-sm-6">
 <p className="mb-0">
 <i className="fa fa-arrow-right text-primary me-2" />
 Sport dans le monde
 </p>
 </div>
 <div className="col-sm-6">
 <p className="mb-0">
 <i className="fa fa-arrow-right text-primary me-2" />
 Assistance visa et voyages
 </p>
 </div>
 <div className="col-sm-6">
 <p className="mb-0">
 <i className="fa fa-arrow-right text-primary me-2" />
 Gestion d'événements
 </p>
 </div>
 </div>
 </div>
 </div>
 </div>
 </div>
 {/* About End */}
 {/* Team Start 
 <div className="container-xxl py-5">
 <div className="container">
 <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
 <h6 className="section-title bg-white text-center px-3" style={{color:'#2B4C7E'}}>
 Guide de Voyage
 </h6>
 <h1 className="mb-5">Notre Equipe</h1>
 </div>
 <div className="row g-4 justify-content-center">
 <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.5s">
 <div className="team-item" style={{
 borderRadius: '20px',
 overflow: 'hidden',
 boxShadow: '0 10px 40px rgba(0,0,0,0.1)',
 transition: 'all 0.4s ease',
 background: 'linear-gradient(145deg, #ffffff 0%, #f8f9fa 100%)',
 border: '1px solid rgba(43, 76, 126, 0.1)'
 }}
 onMouseEnter={(e) => {
 e.currentTarget.style.transform = 'translateY(-15px)';
 e.currentTarget.style.boxShadow = '0 20px 60px rgba(43, 76, 126, 0.25)';
 }}
 onMouseLeave={(e) => {
 e.currentTarget.style.transform = 'translateY(0)';
 e.currentTarget.style.boxShadow = '0 10px 40px rgba(0,0,0,0.1)';
 }}>
 <div className="overflow-hidden" style={{position: 'relative'}}>
 <img className="img-fluid" src="assets/img/chh.jpg" alt="" 
 style={{
 transition: 'transform 0.6s ease',
 width: '100%',
 height: '320px',
 objectFit: 'cover'
 }}
 onMouseEnter={(e) => e.target.style.transform = 'scale(1.1)'}
 onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
 />
 <div style={{
 position: 'absolute',
 top: 0,
 left: 0,
 right: 0,
 bottom: 0,
 background: 'linear-gradient(180deg, transparent 0%, rgba(43, 76, 126, 0.7) 100%)',
 opacity: 0,
 transition: 'opacity 0.4s ease'
 }}
 onMouseEnter={(e) => e.target.style.opacity = '1'}
 onMouseLeave={(e) => e.target.style.opacity = '0'}
 ></div>
 </div>
 <div className="text-center p-4" style={{paddingTop: '2rem'}}>
 <h5 className="mb-2" style={{
 fontWeight: '700',
 color: '#2B4C7E',
 fontSize: '1.25rem'
 }}>Chedly Arfaoui</h5>
 <small style={{
 color: '#6c757d',
 fontSize: '0.9rem',
 fontWeight: '500',
 letterSpacing: '0.5px'
 }}>Désignation</small>
 <div
 className="d-flex justify-content-center"
 style={{ marginTop:"20px", gap: '12px' }}
 >
 <a className="btn btn-square" href="" style={{
 width: '42px',
 height: '42px',
 borderRadius: '50%',
 display: 'flex',
 alignItems: 'center',
 justifyContent: 'center',
 background: 'linear-gradient(135deg, #2B4C7E 0%, #1e3a5f 100%)',
 border: 'none',
 color: 'white',
 transition: 'all 0.3s ease',
 boxShadow: '0 4px 15px rgba(43, 76, 126, 0.3)'
 }}
 onMouseEnter={(e) => {
 e.currentTarget.style.transform = 'translateY(-5px) scale(1.1)';
 e.currentTarget.style.boxShadow = '0 8px 25px rgba(43, 76, 126, 0.4)';
 }}
 onMouseLeave={(e) => {
 e.currentTarget.style.transform = 'translateY(0) scale(1)';
 e.currentTarget.style.boxShadow = '0 4px 15px rgba(43, 76, 126, 0.3)';
 }}>
 <i className="fab fa-facebook-f" />
 </a>
 <a className="btn btn-square" href="" style={{
 width: '42px',
 height: '42px',
 borderRadius: '50%',
 display: 'flex',
 alignItems: 'center',
 justifyContent: 'center',
 background: 'linear-gradient(135deg, #E1306C 0%, #C13584 100%)',
 border: 'none',
 color: 'white',
 transition: 'all 0.3s ease',
 boxShadow: '0 4px 15px rgba(225, 48, 108, 0.3)'
 }}
 onMouseEnter={(e) => {
 e.currentTarget.style.transform = 'translateY(-5px) scale(1.1)';
 e.currentTarget.style.boxShadow = '0 8px 25px rgba(225, 48, 108, 0.4)';
 }}
 onMouseLeave={(e) => {
 e.currentTarget.style.transform = 'translateY(0) scale(1)';
 e.currentTarget.style.boxShadow = '0 4px 15px rgba(225, 48, 108, 0.3)';
 }}>
 <i className="fab fa-instagram" />
 </a>
 </div>
 </div>
 </div>
 </div>
 <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.7s">
 <div className="team-item" style={{
 borderRadius: '20px',
 overflow: 'hidden',
 boxShadow: '0 10px 40px rgba(0,0,0,0.1)',
 transition: 'all 0.4s ease',
 background: 'linear-gradient(145deg, #ffffff 0%, #f8f9fa 100%)',
 border: '1px solid rgba(43, 76, 126, 0.1)'
 }}
 onMouseEnter={(e) => {
 e.currentTarget.style.transform = 'translateY(-15px)';
 e.currentTarget.style.boxShadow = '0 20px 60px rgba(43, 76, 126, 0.25)';
 }}
 onMouseLeave={(e) => {
 e.currentTarget.style.transform = 'translateY(0)';
 e.currentTarget.style.boxShadow = '0 10px 40px rgba(0,0,0,0.1)';
 }}>
 <div className="overflow-hidden" style={{position: 'relative'}}>
 <img className="img-fluid" src="assets/img/moez1.png" alt="" 
 style={{
 transition: 'transform 0.6s ease',
 width: '100%',
 height: '320px',
 objectFit: 'cover'
 }}
 onMouseEnter={(e) => e.target.style.transform = 'scale(1.1)'}
 onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
 />
 <div style={{
 position: 'absolute',
 top: 0,
 left: 0,
 right: 0,
 bottom: 0,
 background: 'linear-gradient(180deg, transparent 0%, rgba(43, 76, 126, 0.7) 100%)',
 opacity: 0,
 transition: 'opacity 0.4s ease'
 }}
 onMouseEnter={(e) => e.target.style.opacity = '1'}
 onMouseLeave={(e) => e.target.style.opacity = '0'}
 ></div>
 </div>
 <div className="text-center p-4" style={{paddingTop: '2rem'}}>
 <h5 className="mb-2" style={{
 fontWeight: '700',
 color: '#2B4C7E',
 fontSize: '1.25rem'
 }}>Moez Hattour</h5>
 <small style={{
 color: '#6c757d',
 fontSize: '0.9rem',
 fontWeight: '500',
 letterSpacing: '0.5px'
 }}>Désignation</small>
 <div
 className="d-flex justify-content-center"
 style={{ marginTop:"20px", gap: '12px' }}
 >
 <a className="btn btn-square" href="" style={{
 width: '42px',
 height: '42px',
 borderRadius: '50%',
 display: 'flex',
 alignItems: 'center',
 justifyContent: 'center',
 background: 'linear-gradient(135deg, #2B4C7E 0%, #1e3a5f 100%)',
 border: 'none',
 color: 'white',
 transition: 'all 0.3s ease',
 boxShadow: '0 4px 15px rgba(43, 76, 126, 0.3)'
 }}
 onMouseEnter={(e) => {
 e.currentTarget.style.transform = 'translateY(-5px) scale(1.1)';
 e.currentTarget.style.boxShadow = '0 8px 25px rgba(43, 76, 126, 0.4)';
 }}
 onMouseLeave={(e) => {
 e.currentTarget.style.transform = 'translateY(0) scale(1)';
 e.currentTarget.style.boxShadow = '0 4px 15px rgba(43, 76, 126, 0.3)';
 }}>
 <i className="fab fa-facebook-f" />
 </a>
 <a className="btn btn-square" href="" style={{
 width: '42px',
 height: '42px',
 borderRadius: '50%',
 display: 'flex',
 alignItems: 'center',
 justifyContent: 'center',
 background: 'linear-gradient(135deg, #1DA1F2 0%, #0d8bd9 100%)',
 border: 'none',
 color: 'white',
 transition: 'all 0.3s ease',
 boxShadow: '0 4px 15px rgba(29, 161, 242, 0.3)'
 }}
 onMouseEnter={(e) => {
 e.currentTarget.style.transform = 'translateY(-5px) scale(1.1)';
 e.currentTarget.style.boxShadow = '0 8px 25px rgba(29, 161, 242, 0.4)';
 }}
 onMouseLeave={(e) => {
 e.currentTarget.style.transform = 'translateY(0) scale(1)';
 e.currentTarget.style.boxShadow = '0 4px 15px rgba(29, 161, 242, 0.3)';
 }}>
 <i className="fab fa-twitter" />
 </a>
 <a className="btn btn-square" href="" style={{
 width: '42px',
 height: '42px',
 borderRadius: '50%',
 display: 'flex',
 alignItems: 'center',
 justifyContent: 'center',
 background: 'linear-gradient(135deg, #E1306C 0%, #C13584 100%)',
 border: 'none',
 color: 'white',
 transition: 'all 0.3s ease',
 boxShadow: '0 4px 15px rgba(225, 48, 108, 0.3)'
 }}
 onMouseEnter={(e) => {
 e.currentTarget.style.transform = 'translateY(-5px) scale(1.1)';
 e.currentTarget.style.boxShadow = '0 8px 25px rgba(225, 48, 108, 0.4)';
 }}
 onMouseLeave={(e) => {
 e.currentTarget.style.transform = 'translateY(0) scale(1)';
 e.currentTarget.style.boxShadow = '0 4px 15px rgba(225, 48, 108, 0.3)';
 }}>
 <i className="fab fa-instagram" />
 </a>
 </div>
 </div>
 </div>
 </div>
 </div>
 </div>
 </div>*/}
 {/* Team End */}
 </div>
 )
}

export default About